module.exports = __webpack_public_path__ + "img/Flag_of_Turkmenistan.c7bf7db7.svg";